// Estado de red compartido (no atado a React) para que tanto el hook
// useNetworkStatus como syncQueue puedan consultarlo/suscribirse sin
// duplicar listeners de window.

const listeners = new Set();

function notify() {
  const online = isOnline();
  listeners.forEach((listener) => listener(online));
}

export function isOnline() {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}

export function subscribeNetworkStatus(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', notify);
  window.addEventListener('offline', notify);
}
